import React, { useEffect, useState } from "react";
import ProductScreen from "./ProductScreen";
import ProductScreenMobile from "./ProductScreenMobile";

export default function ResponsiveProductScreen() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <ProductScreenMobile /> : <ProductScreen />;
}